import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {Page} from '../page';
import {Produto} from '../home/home/conteudo/produtos/produto';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {ProdutosService} from '../home/home/conteudo/produtos/produtos.service';

@Component({
    selector: 'store-resultado',
    templateUrl: './resultado.component.html',
    styleUrls: ['./resultado.component.scss']
})
export class ResultadoComponent implements OnInit, OnChanges {

    private PAGEABLE_LIMIT = 20;

    constructor(private router: Router, private produtosService: ProdutosService) {
        this.loading = true;
    }

    @Input()
    public produtos: Observable<Page<Produto>>;

    @Input()
    public tagsPesquisa: Array<string>;

    @Input()
    public filtros: Map<string, any>;

    public resultados: Produto[];
    public total: number;
    public hasNext: boolean;
    public loading: boolean;
    public offset: number;

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.produtos) {
            this.getProdutos();
        }
    }

    getProdutos() {
        this.produtos.subscribe((response: any) => {
            this.resultados = response.content;
            this.total = response.total;
            this.hasNext = response.hasNext;
            this.offset = this.PAGEABLE_LIMIT;
            this.loading = false;
        });
    }

    getSlug(produto) {
        return produto.slug || produto.id;
    }

    getMaisProdutos() {
        this.produtosService.getProdutos(this.filtros, this.tagsPesquisa, this.offset, this.PAGEABLE_LIMIT)
            .subscribe(maisProdutos => {
                this.resultados = this.resultados.concat(maisProdutos.content);
                this.offset = this.offset + this.PAGEABLE_LIMIT;
                this.hasNext = maisProdutos.hasNext;
            });
    }

}
